/* Lumavie — interacciones propias (vanilla, sin librerías) */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.lv-reveal:not(.lv-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window) || document.body.classList.contains('shopify-design-mode')) {
      els.forEach(function (el) { el.classList.add('lv-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('lv-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initParallax() {
    if (reduce) return;
    var items = document.querySelectorAll('[data-lv-parallax]');
    if (!items.length) return;
    var ticking = false;
    function update() {
      items.forEach(function (el) {
        var k = parseFloat(el.getAttribute('data-lv-parallax')) || 0;
        var r = el.parentElement.getBoundingClientRect();
        var center = r.top + r.height / 2 - window.innerHeight / 2;
        el.style.transform = 'translate3d(0,' + (center * -k / 100).toFixed(1) + 'px,0) scale(1.08)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  function initTabs(root) {
    (root || document).querySelectorAll('[data-lv-tabs]').forEach(function (wrap) {
      if (wrap.dataset.lvReady) return; wrap.dataset.lvReady = '1';
      var tabs = wrap.querySelectorAll('.lv-tab');
      var panels = wrap.querySelectorAll('.lv-tabs__panel');
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          tabs.forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-selected', 'false'); });
          panels.forEach(function (p) { p.classList.remove('is-active'); });
          t.classList.add('is-active'); t.setAttribute('aria-selected', 'true');
          if (panels[i]) panels[i].classList.add('is-active');
        });
      });
    });
  }

  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    fmt = fmt || '${{amount}}';
    return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ','))
              .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
              .replace(/\{\{\s*amount\s*\}\}/, withComma);
  }

  function initProduct(root) {
    (root || document).querySelectorAll('[data-lv-product]').forEach(function (wrap) {
      if (wrap.dataset.lvReady) return; wrap.dataset.lvReady = '1';
      var main = wrap.querySelector('.lv-gallery__main img');
      var thumbs = wrap.querySelectorAll('.lv-gallery__thumb');
      function showMedia(src, srcset, alt) {
        if (!main) return;
        main.style.opacity = '0';
        setTimeout(function () { main.src = src; if (srcset) main.srcset = srcset; main.alt = alt || ''; main.style.opacity = '1'; }, 150);
      }
      var mainBox = wrap.querySelector('.lv-gallery__main');
      var countEl = wrap.querySelector('[data-lv-count]');
      var idx = 0;
      thumbs.forEach(function (th, i) { if (th.classList.contains('is-active')) idx = i; });
      function preload(i) { var t = thumbs[(i + thumbs.length) % thumbs.length]; if (t) { var im = new Image(); im.src = t.dataset.src; } }
      function setCount() { if (countEl && thumbs.length) countEl.textContent = (idx + 1) + ' / ' + thumbs.length; }
      function go(i) {
        if (!thumbs.length) return;
        idx = (i + thumbs.length) % thumbs.length;
        var th = thumbs[idx];
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        th.classList.add('is-active');
        showMedia(th.dataset.src, th.dataset.srcset, th.dataset.alt);
        setCount(); preload(idx + 1);
      }
      setCount(); if (thumbs.length > 1) preload(idx + 1);
      thumbs.forEach(function (th, i) { th.addEventListener('click', function () { go(i); }); });
      if (mainBox && thumbs.length > 1) {
        var pv = mainBox.querySelector('[data-lv-prev]'), nx = mainBox.querySelector('[data-lv-next]');
        var swiped = false;
        if (pv) pv.addEventListener('click', function (e) { e.stopPropagation(); go(idx - 1); });
        if (nx) nx.addEventListener('click', function (e) { e.stopPropagation(); go(idx + 1); });
        mainBox.addEventListener('click', function (e) { if (swiped || e.target.closest('button')) return; if (window.lvLightbox) window.lvLightbox(Array.prototype.map.call(thumbs, function (t) { return { src: t.dataset.src.replace(/([?&]width=)\d+/, '$11800'), alt: t.dataset.alt }; }), idx); else go(idx + 1); });
        mainBox.setAttribute('tabindex', '0');
        mainBox.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1); }
        });
        var sx = null, sy = null;
        mainBox.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
        mainBox.addEventListener('touchend', function (e) {
          if (sx === null) return;
          var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
            go(dx < 0 ? idx + 1 : idx - 1);
            swiped = true; setTimeout(function () { swiped = false; }, 400);
          }
          sx = sy = null;
        }, { passive: true });
      }

      var qty = wrap.querySelector('.lv-qty input');
      wrap.querySelectorAll('.lv-qty button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(qty.value, 10) || 1;
          v = b.dataset.step === '+' ? v + 1 : Math.max(1, v - 1);
          qty.value = v;
        });
      });

      var dataEl = wrap.querySelector('script[data-lv-variants]');
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var fmt = wrap.dataset.moneyFormat;
      var idInput = wrap.querySelector('input[name="id"]');
      var priceNow = wrap.querySelectorAll('[data-lv-price]');
      var priceOld = wrap.querySelectorAll('[data-lv-compare]');
      var saveEl = wrap.querySelector('[data-lv-save]');
      var sticky = document.querySelector('[data-lv-sticky-for="' + wrap.id + '"]');
      var btns = Array.prototype.slice.call(wrap.querySelectorAll('[data-lv-add]'));
      if (sticky) { btns = btns.concat(Array.prototype.slice.call(sticky.querySelectorAll('[data-lv-add]'))); priceNow = Array.prototype.slice.call(priceNow).concat(Array.prototype.slice.call(sticky.querySelectorAll('[data-lv-price]'))); }
      var soldText = wrap.dataset.soldOut; var addText = wrap.dataset.addText;

      function current() {
        var sel = [];
        wrap.querySelectorAll('.lv-opt').forEach(function (fs) {
          var c = fs.querySelector('input:checked'); sel.push(c ? c.value : null);
        });
        return variants.find(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); });
      }
      function update() {
        var v = current();
        btns.forEach(function (b) {
          b.disabled = !v || !v.available;
          var label = b.querySelector('span') || b;
          label.textContent = !v ? soldText : (v.available ? addText : soldText);
        });
        if (!v) return;
        idInput.value = v.id;
        priceNow.forEach(function (el) { el.textContent = money(v.price, fmt); });
        var hasCompare = v.compare_at_price && v.compare_at_price > v.price;
        priceOld.forEach(function (el) { el.textContent = hasCompare ? money(v.compare_at_price, fmt) : ''; el.hidden = !hasCompare; });
        if (saveEl) {
          if (hasCompare) { saveEl.hidden = false; saveEl.textContent = saveEl.dataset.label.replace('[x]', Math.round((1 - v.price / v.compare_at_price) * 100) + '%'); }
          else saveEl.hidden = true;
        }
        if (window.history && window.history.replaceState && wrap.dataset.updateUrl === 'true') {
          var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u.toString());
        }
      }
      wrap.querySelectorAll('.lv-opt input').forEach(function (i) { i.addEventListener('change', update); });

      if (sticky) {
        var sBtn = sticky.querySelector('button');
        if (sBtn) sBtn.addEventListener('click', function () {
          var form = wrap.querySelector('form[action*="/cart/add"]');
          if (form) { if (form.requestSubmit) form.requestSubmit(); else form.submit(); }
        });
        var target = wrap.querySelector('.lv-buy__row');
        if (target && 'IntersectionObserver' in window) {
          new IntersectionObserver(function (en) {
            en.forEach(function (e) { var lvMob = window.matchMedia && window.matchMedia('(max-width: 749px)').matches; sticky.classList.toggle('is-visible', !e.isIntersecting && (lvMob || e.boundingClientRect.top < 0)); });
          }).observe(target);
        }
      }
    });
  }

  function initAll(root) { initReveal(root); initTabs(root); initProduct(root); }

  document.addEventListener('DOMContentLoaded', function () {
    document.documentElement.classList.remove('lv-no-js');
    initAll(document); initParallax();
  });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var t = e.target; if (t && t.classList && t.classList.contains('lv-tab')) t.click();
  });

  /* Lumavie: añadir desde "completa tu rutina" en el carrito */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-lv-upsell]');
    if (!b) return;
    e.preventDefault();
    b.disabled = true; b.classList.add('is-loading');
    var drawer = document.querySelector('cart-drawer');
    var sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : [];
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(b.dataset.lvUpsell), quantity: 1 }], sections: sections, sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) throw new Error(res.description || 'error');
      if (drawer && drawer.renderContents && res.sections && !/\/cart\/?$/.test(location.pathname)) {
        res.id = res.items && res.items[0] ? res.items[0].key : res.id;
        drawer.renderContents(res);
      } else { window.location.reload(); }
    }).catch(function () { window.location.reload(); });
  });


  /* Lumavie: visor de fotos a pantalla completa (lightbox) */
  (function () {
    var box, img, cnt, list = [], cur = 0, sx = null, sy = null;
    function build() {
      box = document.createElement('div');
      box.className = 'lv-lb'; box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true'); box.hidden = true;
      box.innerHTML = '<button type="button" class="lv-lb__close" aria-label="Close">&times;</button>' +
        '<button type="button" class="lv-lb__nav lv-lb__nav--prev" aria-label="Previous"><svg viewBox="0 0 24 24" width="24" height="24"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
        '<figure class="lv-lb__fig"><img alt=""></figure>' +
        '<button type="button" class="lv-lb__nav lv-lb__nav--next" aria-label="Next"><svg viewBox="0 0 24 24" width="24" height="24"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
        '<span class="lv-lb__count"></span>';
      document.body.appendChild(box);
      img = box.querySelector('img'); cnt = box.querySelector('.lv-lb__count');
      box.querySelector('.lv-lb__close').addEventListener('click', close);
      box.querySelector('.lv-lb__nav--prev').addEventListener('click', function (e) { e.stopPropagation(); show(cur - 1); });
      box.querySelector('.lv-lb__nav--next').addEventListener('click', function (e) { e.stopPropagation(); show(cur + 1); });
      box.addEventListener('click', function (e) { if (e.target === box || e.target.classList.contains('lv-lb__fig')) close(); });
      box.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
      box.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(dx < 0 ? cur + 1 : cur - 1);
        else if (dy > 90) close();
        sx = sy = null;
      }, { passive: true });
      document.addEventListener('keydown', function (e) {
        if (box.hidden) return;
        if (e.key === 'Escape') close();
        if (e.key === 'ArrowRight') show(cur + 1);
        if (e.key === 'ArrowLeft') show(cur - 1);
      });
    }
    function show(i) {
      cur = (i + list.length) % list.length;
      img.src = list[cur].src; img.alt = list[cur].alt || '';
      cnt.textContent = list.length > 1 ? (cur + 1) + ' / ' + list.length : '';
      box.classList.toggle('lv-lb--single', list.length < 2);
      var n = list[(cur + 1) % list.length]; if (n) { var p = new Image(); p.src = n.src; }
    }
    function close() { box.hidden = true; document.documentElement.classList.remove('lv-lb-open'); }
    window.lvLightbox = function (items, start) {
      if (!items || !items.length) return;
      if (!box) build();
      list = items; box.hidden = false; document.documentElement.classList.add('lv-lb-open');
      show(start || 0); box.querySelector('.lv-lb__close').focus();
    };
    document.addEventListener('click', function (e) {
      var im = e.target.closest && e.target.closest('[data-lv-zoom-group] img');
      if (!im || e.target.closest('button')) return;
      var g = im.closest('[data-lv-zoom-group]');
      var imgs = Array.prototype.filter.call(g.querySelectorAll('img'), function (x) { return !x.closest('button'); });
      var items = imgs.map(function (x) { return { src: (x.currentSrc || x.src).replace(/([?&]width=)\d+/, '$11800'), alt: x.alt }; });
      window.lvLightbox(items, Math.max(0, imgs.indexOf(im)));
    });
    /* flechas en pestañas (cabezales / zonas) */
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-lv-tabstep]');
      if (!b) return;
      e.preventDefault(); e.stopPropagation();
      var wrap = b.closest('[data-lv-tabs]'); if (!wrap) return;
      var tabs = Array.prototype.slice.call(wrap.querySelectorAll('.lv-tab'));
      var a = tabs.findIndex(function (t) { return t.classList.contains('is-active'); });
      var n = tabs[(a + Number(b.dataset.lvTabstep) + tabs.length) % tabs.length]; if (n) n.click();
    });
  })();
})();
